import { ApiUrl } from '@common/enums';
import { ApplianceModel } from '@common/models';
import { CommonProductQueryParams } from '@ee-api/queryParams';

import { staticContentService } from '../staticContentService';

const dishwasherApi = staticContentService.injectEndpoints({
    endpoints: (builder) => ({
        fetchProgramDishwashers: builder.query<ApplianceModel[], CommonProductQueryParams>({
            query: () => ({
                url: ApiUrl.DISHWASHERS,
                method: 'GET',
            }),
        }),
        fetchInStoreDishwashers: builder.query<ApplianceModel[], { url: string }>({
            query: ({ url }) => ({
                url,
                method: 'GET',
            }),
        }),
    }),
});

export const { useFetchInStoreDishwashersQuery, useFetchProgramDishwashersQuery } = dishwasherApi;
